export class KeyValuePair{
    key: any;
    value: any;
}


// WEBPACK FOOTER //
// ./src/app/models/common/keyValuePair.ts